<template>
  <div>
    <v-container :class="ui.bkgdColor">
      <v-layout row>
        <v-spacer/>
        <v-btn :color="ui.colorWarning" @click="authDetail()" flat
          v-if="btnSpinChangeDetail === false"
          :disabled="!this.enableAuthorise || !this.licenceOK">
          <v-icon left> cloud </v-icon>
          SEND
        </v-btn>
        <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import authDetail from "@/support/detail/mixins/authDetail.js";
// import GetDetailPage from "@/support/detail/components/GetDetailPage";

export default {
  data() {
    return {
      valid: true,
      btnSpinChangeDetail: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      }
    };
  },
  mixins: [apptheme, authDetail, licenceFunctions, adminFunctions],
  components: {
    BtnSpin
    // GetDetailPage
  },
  computed: {
    ...mapGetters([
      "getCurrentPage",
      "getDataSavePendingIndication",
      "getTransitions"
    ]),
    ui() {
      return this.uiTheme1;
    },
    enableAuthorise() {
      let logic = null;
      let trans = this.getTransitions;
      if (
        this.getDataSavePendingIndication === true &&
        trans !== null &&
        trans !== undefined &&
        trans.hist.length > trans.flow.length &&
        trans.model === "Y" &&
        trans.level > 0
      ) {
        logic = true;
      } else if (
        this.getDataSavePendingIndication === true &&
        trans !== null &&
        trans !== undefined &&
        trans.model === "Y" &&
        trans.level > 1
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  },
  methods: {
    closeDetail() {
      if (this.getCurrentPage == "/maintstrategyedit") {
        this.$router.push("/facilitydashmaint");
      }
    }
  }
};
</script>
